module.exports = __webpack_public_path__ + "img/botella_black_4_2.7586fb7b.png";